<template>
  <div class='statistical-data' v-if="accountInfo">
    <div class="st-top">Alpha Bot 已安全交易金额: <span class="font2">$ {{$format(totalVol)}}</span></div>
    <div class="st-bottom">
      <div class="top-section">
        <div>
          <p>今日交易额</p>
          <span class="font2"><em>$</em><b>{{$formatWithCommas(todayVol)}}</b></span>
        </div>
        <div>
          <p>今日已获取 Alpha 积分</p>
          <span class="font2"><b>{{allJs}}</b><em>积分</em></span>
        </div>
      </div>
      <div class="bottom-section">
        <div>
          <p>Gas 余额 (新用户5U赠送金)</p>
          <span class="font2"><em>$</em><b>{{$formatDecimals(balance)}}</b></span>
        </div>
        <div>
          <span class="recharge-btn" @click="showRechargePopup = true">充值</span>
          <span class="withdraw-btn" @click="showWithdrawPopup = true">提现</span>
        </div>
      </div>
    </div>

    <!-- 充值弹窗 -->
    <recharge-popup :show.sync="showRechargePopup" @recharge="handleRecharge"></recharge-popup>
    <!-- 提现弹窗 -->
    <withdraw-popup :balance="balance" :show.sync="showWithdrawPopup" @withdraw="handleWithdraw"></withdraw-popup>
  </div>
</template>

<script>
import RechargePopup from './recharge_popup.vue';
import WithdrawPopup from './withdraw_popup.vue';
import {mapState} from "vuex";
export default {
  name: "statistical_data",
  components: {
    RechargePopup,
    WithdrawPopup
  },
  props: ["balance","todayVol","allJs","todayTradeList","totalVol"],
  data() {
    return {
      showRechargePopup: false,
      showWithdrawPopup: false
    };
  },
  computed: {
    ...mapState([
      "accountInfo",
    ]),
  },
  methods: {
    handleRecharge(amount) {
      console.log('充值金额:', amount);
      // TODO
      this.$toast(`已成功充值 ${amount} USDT`);
    },
    handleWithdraw(data) {
      console.log('提现信息:', data);
      // TODO
      this.$toast(`已成功提交提现申请，金额: ${data.amount} USDT`);
    }
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.statistical-data {
  width: 100%;
  border-radius: 12px;
  background-color: #000;
  color: #fff;
  margin-top: 4px;

  .st-top {
    padding: 8px 15px;
    font-size: 12px;
    font-weight: 500;
    span{
      font-size: 14px;
    }
  }

  .st-bottom {
    background-color: #fff;
    border-radius: 12px;
    display: flex;
    padding:  0 15px;
    flex-direction: column;
    border: 0.5px solid #000;

    .top-section {
      display: flex;
      justify-content: space-between;
      padding: 15px 0 13px 0;
      border-bottom: 0.5px solid $border;

      > div {
        width: 50%;

        p {
          color: $color1;
          font-size: 12px;
          padding-bottom: 3px;
        }

        span {
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #000;
          em{
            font-size: 16px;
          }
        }
      }
    }

    .bottom-section {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding: 15px 0 13px 0;

      > div {
        width: 50%;

        &:last-child {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        p {
          color: $color1;
          font-size: 12px;
          padding-bottom: 3px;
        }

        span {
          font-size: 20px;
          color: #000;
          display: flex;
          align-items: center;
          em{
            font-size: 16px;
          }

          &.recharge-btn, &.withdraw-btn {
            font-size: 12px;
            padding: 0 24.5px;
            height: 33px;
            line-height: 33px;
            border-radius: 8px;
            cursor: pointer;
            display: inline-block;
            text-align: center;
          }

          &.recharge-btn {
            background-color: $color;
            color: #fff;
          }

          &.withdraw-btn {
            background-color: $bg;
            color: #000;
          }
        }
      }
    }
  }
}
</style>